import { DlvPipelineError, DlvStatusMessage } from 'models/jobs/jobs';
const dlvPipelineErrorRec = {
    [DlvPipelineError.UnsupportedLicenseType]: 'Unsupported License Type',
    [DlvPipelineError.UnsupportedCountry]: 'Unsupported Country',
    [DlvPipelineError.MissingState]: 'Missing State',
    [DlvPipelineError.MissingLicenseNumber]: 'Missing License Number',
    [DlvPipelineError.IdentificationTypeUnsupportedByState]: 'Identification Card Validation Unsupported By State'
};
export const getVisualDlvStatus = (dlvStatusMessage, dlvError, dlvStateSupported) => {
    if (dlvStatusMessage === DlvStatusMessage.ERROR) {
        if (dlvError && dlvPipelineErrorRec[dlvError]) {
            return dlvPipelineErrorRec[dlvError];
        }
        return DlvStatusMessage.ERROR;
    }
    if (dlvStateSupported === false) {
        return 'Unsupported State';
    }
    return dlvStatusMessage;
};
export const getDlvMatch = (dlvResult, field) => {
    if (dlvResult.fieldMatchesUnavailable.includes(field)) {
        return undefined;
    }
    if (dlvResult.fieldMatchesAvailable.includes(field)) {
        if (dlvResult.fieldMatchesSucceeded.includes(field)) {
            return true;
        }
        if (dlvResult.fieldMatchesFailed.includes(field)) {
            return false;
        }
    }
    return undefined;
};
